<template>
    <div class="main-notfound d-flex flex-column justify-content-center align-items-center">
        <h1 class="text-danger fs-3 fw-bold"><i class="fas fa-exclamation-triangle"></i> Belə səhifə tapılmadı !</h1>
    </div>
</template>

<script>

export default {
    title: "page_not_found",
    name: "NotFound",
    components: {},
    setup(){
        return {};
    }
};
</script>

<style lang="scss">
    .main-notfound {
        height: calc( 100vh - 150px );
    }
    .main-notfound img{
        width: 200px;
        margin-bottom: 20px;
        background: linear-gradient(70deg, #f00, #000);
    }
</style>
